import React from "react";

const features = [
  {
    icon: "💻",
    title: "Web Development",
    desc: "High-performance, responsive websites built for speed, security, and growth.",
  },
  {
    icon: "📱",
    title: "Mobile Apps",
    desc: "Custom Android and iOS applications designed for an excellent user experience.",
  },
  {
    icon: "🎨",
    title: "UI/UX Design",
    desc: "Creative designs that engage users and enhance your brand identity.",
  },
];

const About = () => {
  return (
    <section className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 px-6 py-20">
      
      {/* Heading */}
      <div className="text-center mb-12">
        <h2 className="text-4xl md:text-5xl font-bold text-blue-600 mb-4">
          About Us
        </h2>
        <p className="text-gray-700 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
          NextWys is a tech solutions company delivering modern web development,
          UI/UX design, mobile apps, branding, and digital innovation to help
          businesses grow online.
        </p>
      </div>

      {/* Features */}
      <div className="max-w-5xl mx-auto grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {features.map((item, index) => (
          <div
            key={index}
            className="relative bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl hover:-translate-y-2 transition-all duration-300 text-center group"
          >
            {/* Hover Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 opacity-0 group-hover:opacity-10 transition duration-500 pointer-events-none rounded-2xl"></div>

            {/* Content */}
            <div className="relative z-10">
              <div className="text-5xl mb-4 text-blue-600">
                {item.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                {item.desc}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Call-to-Action */}
      <div className="mt-16 text-center">
        <p className="text-gray-700 text-lg md:text-xl max-w-2xl mx-auto mb-6">
          We combine technology, creativity, and strategy to bring your ideas to
          life and grow your business online.
        </p>
        <a
          href="#contact"
          className="inline-block bg-blue-600 text-white px-8 py-3 rounded-full font-semibold shadow-md hover:bg-blue-700 transition-colors duration-300"
        >
          Get in Touch
        </a>
      </div>
    </section>
  );
};

export default About;